export const defualtPageLengths = [10];
export const cardsPageLengths = [10, 20, 50, 100];
export const accountsDownloadFileName = 'my_accounts.xls';
export const cardsDownloadFileName = 'my_cards.xls';
export const costCentresDownloadFileName = 'my_cost_centres.xls';
export const transactionsDownloadFileName = 'my_transactions.xls';
export const invoiceStatementFileName = 'my_invoice_statement';
export const usersFileName = 'users.xls';
export const pendingTransfersDownloadFileName = 'pending_transfers.xls';
export const EXPIRY_DAYS_WARNING_THRESHOLD = 55;
export const MEDIUM_THROTTLE = 1000;
